import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import Reveal from './Reveal';
import './CTA.css';

const CTA = ({
  title = 'Have a project in mind?',
  description = "Tell us what you're building. We'll get back to you with a plan, a timeline and an honest estimate.",
  primary = { to: '/contact', label: 'Start a project' },
  secondary = { to: '/portfolio', label: 'See our work' },
}) => (
  <section className="section cta">
    <div className="container">
      <Reveal className="cta-panel">
        <div className="cta-grid" aria-hidden="true" />
        <div className="cta-orb" aria-hidden="true" />
        <div className="cta-body">
          <span className="eyebrow">Let's build</span>
          <h2 className="cta-title">{title}</h2>
          <p className="cta-description">{description}</p>
          <div className="btn-row cta-actions">
            <Link to={primary.to} className="btn btn-primary btn-large">
              {primary.label}
              <Icon name="arrowRight" />
            </Link>
            {secondary && (
              <Link to={secondary.to} className="btn btn-secondary btn-large">
                {secondary.label}
              </Link>
            )}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTA;
